import React from 'react';
import './SwitchSnippet.css';

const SwitchSnippet = () => {
  return (
    <pre>
      <code>
        <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-switch</span><span class="cln">"</span><span class="cn">&gt;</span><br />
        <span class="cn">  &lt;input</span><span class="cln"> type="</span><span class="cn">checkbox</span><span class="cln">" name="</span><span class="cn">toggle-carve-switch</span><span class="cln">" id="</span><span class="cn">toggleSwitch</span><span class="cln">"/&gt;</span><br />
        <span class="cn">  &lt;label</span><span class="cln"> for="</span><span class="cn">toggleSwitch</span><span class="cln">"</span><span class="cn">&gt;</span><br />
        <span class="cn">    &lt;span</span><span class="cln"> class="</span><span class="cn">on</span><span class="cln">"</span><span class="cn">&gt;</span>ON<span class="cn">&lt;/span&gt;</span><br />
        <span class="cn">    &lt;span</span><span class="cln"> class="</span><span class="cn">off</span><span class="cln">"</span><span class="cn">&gt;</span>OFF<span class="cn">&lt;/span&gt;</span><br />
        <span class="cn">  &lt;/label&gt;</span><br />
        <span class="cn">&lt;/div&gt;</span>

      </code>
    </pre>

  );
}

SwitchSnippet.propTypes = {};

export default SwitchSnippet;
